import React from "react";
import styled from "styled-components";

const SubsectionTitleDiv = styled.div`  
  font-size: 17px;
  color:rgb(153, 153, 153);
`;

const SubsectionTitle = props => <SubsectionTitleDiv>{props.title.toUpperCase()}</SubsectionTitleDiv>;
export default SubsectionTitle;
